/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a water bath.
 */
export type AnimaticWaterBathConfig = {};

/** @internal */
export const AnimaticWaterBathConfig$inboundSchema: z.ZodType<
  AnimaticWaterBathConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticWaterBathConfig$Outbound = {};

/** @internal */
export const AnimaticWaterBathConfig$outboundSchema: z.ZodType<
  AnimaticWaterBathConfig$Outbound,
  z.ZodTypeDef,
  AnimaticWaterBathConfig
> = z.object({});

export function animaticWaterBathConfigToJSON(
  animaticWaterBathConfig: AnimaticWaterBathConfig,
): string {
  return JSON.stringify(
    AnimaticWaterBathConfig$outboundSchema.parse(animaticWaterBathConfig),
  );
}
export function animaticWaterBathConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticWaterBathConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticWaterBathConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticWaterBathConfig' from JSON`,
  );
}
